import { Link } from "react-router-dom";
import { ArrowRight, Flag, CalendarBlank } from "@phosphor-icons/react";
import { Reveal, Eyebrow } from "./Reveal";
import { SCAMWATCH } from "../data/scamwatch";

export default function ScamWatch() {
  const [latest, ...archive] = SCAMWATCH;
  return (
    <section id="scamwatch" data-testid="scamwatch-section" className="py-24 md:py-36 border-t border-border">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Eyebrow>Red Flag Friday</Eyebrow>
            <h2 className="font-serif text-primary tracking-tight text-4xl sm:text-5xl mt-6 leading-[1.08]" data-testid="scamwatch-heading">
              The scam script <em className="text-accent">of the week</em>
            </h2>
          </div>
          <p className="text-foreground/60 max-w-sm text-sm md:text-base md:text-right">
            Every week we dissect one real script doing the rounds — so it can never work on you twice.
          </p>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-12 gap-8">
          <Reveal className="lg:col-span-7" delay={0.1}>
            <Link
              to={`/scamwatch/${latest.slug}`}
              data-testid="scamwatch-latest"
              className="group block h-full bg-primary text-primary-foreground rounded-sm p-10 md:p-14 hover:-translate-y-1 transition-transform duration-500"
            >
              <div className="flex items-center gap-4 text-xs font-bold uppercase tracking-[0.2em] text-primary-foreground/50">
                <span className="flex items-center gap-2"><Flag size={15} weight="fill" className="text-accent" /> Episode {latest.number}</span>
                <span className="flex items-center gap-2"><CalendarBlank size={15} weight="bold" /> {latest.date}</span>
              </div>
              <h3 className="font-serif text-3xl md:text-5xl tracking-tight mt-8 leading-[1.1] group-hover:text-accent transition-colors duration-300">
                {latest.title}
              </h3>
              <p className="mt-6 text-primary-foreground/70 leading-relaxed max-w-xl">{latest.teaser}</p>
              <span className="mt-10 inline-flex items-center gap-2 text-sm font-semibold text-accent">
                Read the dissection
                <ArrowRight size={16} weight="bold" className="transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </Link>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={0.2}>
            <div className="h-full flex flex-col gap-4">
              {archive.map((ep) => (
                <Link
                  key={ep.slug}
                  to={`/scamwatch/${ep.slug}`}
                  data-testid={`scamwatch-archive-${ep.slug}`}
                  className="group flex-1 bg-card border border-border rounded-sm p-7 hover:border-accent/60 hover:-translate-y-0.5 transition-[border-color,transform] duration-300"
                >
                  <div className="flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.2em] text-muted-foreground">
                    <span>Episode {ep.number}</span>
                    <span aria-hidden>·</span>
                    <span>{ep.date}</span>
                  </div>
                  <h4 className="font-serif text-xl md:text-2xl text-primary tracking-tight mt-3 group-hover:text-accent transition-colors duration-300">
                    {ep.title}
                  </h4>
                  <p className="mt-2 text-sm text-foreground/60 line-clamp-2">{ep.teaser}</p>
                </Link>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
